<template>
<v-dialog
    v-model="dialog"
    max-width="920"
    v-if="process != null"
>
    <v-card>
        <v-card-title>Report Progress: {{process.report_label}}</v-card-title>

        <v-card-text>
            <div
                v-if="process.state == 'running'"
                style="margin-top: 15px"
            >
                <p>The report is running.</p>

                <div
                    style="margin-top: 15px; margin-bottom: 15px; text-align: center"
                >
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    />
                </div>

            </div>  

            <div
                v-else-if="process.state == 'finished-success'"
                style="margin-top: 15px"
            >
                <v-icon
                    v-on:click="onClickDownlad()"
                    style="margin-right: 15px"
                >
                    mdi-download
                </v-icon>

                <a v-on:click="onClickDownlad()" style="text-decoration: underline">Download finished report</a>
                
            </div>  
            
            <div
                v-else
                style="margin-top: 15px"
            >
                {{process.state}}
            </div>
            
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

        
            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    props: {
        public: {
            type: Boolean,
            default: function() { return false; },
        },
    },

    data() {
        return {
            dialog: false,
            process: null,
        }
    },

    methods: {

        showDialog(process)
        {
            this.process = _.cloneDeep(process);
            this.dialog = true;

            this.doUpdate();
        },

        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/reports/:report_process_id',
            
                'params' : {
                        'report_process_id': this.process.report_process_id,
                    },
            
                'on_success': (data) => {
                        this.process = data;

                        if ( this.process.state == 'running' )
                        {
                            window.setTimeout(this.doUpdate, 1000);
                        }
                    },
            
                'on_error': 'Unable to update progress',
            });
        },

        onOk()
        {
            this.dialog = false;
         
            if ( this.public )
                return;
            
            this.$router.push({
                'name': 'admin-reports',
                'params' : {
                }
            });
        },

        onClickDownlad()
        {
            window.open(this.process.excel_blob_url, '_blank');  
        },

    },
}
</script>

<style lang="scss" scoped>
</style>